import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    activeMappedItem: null,   // The active mappedItem that the user is working on
    activeMappedItemInput: null,  // The input to write the mapped value for the active mapped item
    brand: null,              // The brand (string) to filter the active feature's values
    classification: null,     // The selected and active classification
    classifications: [],      // All the classifications with {id, name, parentId, treeName}
    feature: null,            // The active feature with {id, name}
    features: [],             // All the features of the current active classification with {id, name}
    loadingClassifications: false,  // Indicates that the app is getting the classifications using the api
    loadingFeatures: false,   // Indicates that the app is getting the features using the api
    loadingMappedItems: false,  // Is loading the mapped values
    loadingRemoveValue: false,  // Is removing a value from its mapped group
    loadingSaveActiveMap: false,  // Is saving the active map
    mappedItems: null,        // The mapped items array of objects with {value, mapped, frequency, brands, frequencyByBrand}
    showingMappedValues: false, // The app is showing the mapped values, not the raw values
    showingSidebar: true,     // The sidebar is a temporary sidebar that when clicked outside is hidden
    temporarySidebar: false,  // Controls the visibility of the sidebar
  }
}
